import './styles.scss';

import React, {CSSProperties} from 'react';

import {KashHtmlAttributes} from '../../../types/KashHtmlAttributes';

interface AppModalHeadProps extends KashHtmlAttributes<HTMLDivElement> {
    title: string;
    text?: string;
    src: string;
    style?: CSSProperties;
}

export const AppModalHead = ({title, text, src, style}: AppModalHeadProps) => {
    return (
        <div className='app-modal-head' style={style}>
            <div className='app-modal-head__title'>
                <img className='app-modal-head__image' src={src} alt={title} />
                <h2>{title}</h2>
            </div>
            {text && <p className='app-modal-head__text'>{text}</p>}
        </div>
    );
};
